import { defineComponent as tt, watchEffect as q, ref as P, toRef as ie, computed as f, h as i, Fragment as oe, nextTick as at } from "vue";
import { createPageItemsInfo as nt } from "./ghl-ui.es1051.js";
import it from "./ghl-ui.es1052.js";
import { useRtl as ot } from "./ghl-ui.es857.js";
import { warn as rt, warnOnce as re } from "./ghl-ui.es859.js";
import st from "./ghl-ui.es860.js";
import pe from "./ghl-ui.es861.js";
import lt from "./ghl-ui.es911.js";
import se from "./ghl-ui.es692.js";
import { smallerSize as le } from "./ghl-ui.es994.js";
import { createKey as r } from "./ghl-ui.es704.js";
import { useThemeClass as dt } from "./ghl-ui.es862.js";
import { resolveSlot as ut } from "./ghl-ui.es865.js";
import de from "./ghl-ui.es201.js";
import ct from "./ghl-ui.es304.js";
import y from "./ghl-ui.es867.js";
import ue from "./ghl-ui.es1053.js";
import ce from "./ghl-ui.es1054.js";
import fe from "./ghl-ui.es1055.js";
import me from "./ghl-ui.es1056.js";
import ge from "./ghl-ui.es1057.js";
import ft from "./ghl-ui.es300.js";
import mt from "./ghl-ui.es1058.js";
import { call as R } from "./ghl-ui.es898.js";
import { useAdjustedTo as gt } from "./ghl-ui.es914.js";
const pt = Object.assign(Object.assign({}, pe.props), {
  simple: Boolean,
  page: Number,
  defaultPage: {
    type: Number,
    default: 1
  },
  itemCount: Number,
  pageCount: Number,
  defaultPageCount: {
    type: Number,
    default: 1
  },
  showSizePicker: Boolean,
  pageSize: Number,
  defaultPageSize: Number,
  pageSizes: {
    type: Array,
    default() {
      return [10];
    }
  },
  showQuickJumper: Boolean,
  size: {
    type: String,
    default: "medium"
  },
  disabled: Boolean,
  pageSlot: {
    type: Number,
    default: 9
  },
  selectProps: Object,
  prev: Function,
  next: Function,
  goto: Function,
  prefix: Function,
  suffix: Function,
  label: Function,
  displayOrder: {
    type: Array,
    default: ["pages", "size-picker", "quick-jumper"]
  },
  to: gt.propTo,
  "onUpdate:page": [Function, Array],
  onUpdatePage: [Function, Array],
  "onUpdate:pageSize": [Function, Array],
  onUpdatePageSize: [Function, Array],
  /** @deprecated */
  onPageSizeChange: [Function, Array],
  /** @deprecated */
  onChange: [Function, Array]
}), Dt = tt({
  name: "Pagination",
  props: pt,
  setup(t) {
    process.env.NODE_ENV !== "production" && q(() => {
      t.pageCount !== void 0 && t.itemCount !== void 0 && rt("pagination", "`page-count` and `item-count` should't be specified together. Only `item-count` will take effect."), t.onPageSizeChange && re("pagination", "`on-page-size-change` is deprecated, please use `on-update:page-size` instead."), t.onChange && re("pagination", "`on-change` is deprecated, please use `on-update:page` instead.");
    });
    const { mergedComponentPropsRef: n, mergedClsPrefixRef: d, inlineThemeDisabled: j, mergedRtlRef: m } = st(t), g = pe("Pagination", "-pagination", it, mt, t, d), { localeRef: T } = lt("Pagination"), $ = P(null), U = P(t.defaultPage), E = P((() => {
      const { defaultPageSize: e } = t;
      if (e !== void 0)
        return e;
      const a = t.pageSizes[0];
      return typeof a == "number" ? a : a.value || 10;
    })()), s = se(ie(t, "page"), U), h = se(ie(t, "pageSize"), E), l = f(() => {
      const { itemCount: e } = t;
      if (e !== void 0)
        return Math.max(1, Math.ceil(e / h.value));
      const { pageCount: a } = t;
      return a !== void 0 ? Math.max(a, 1) : 1;
    }), x = P("");
    q(() => {
      t.simple, x.value = String(s.value);
    });
    const S = P(!1), v = P(!1), V = P(!1), D = P(!1), K = () => {
      t.disabled || (S.value = !0, b());
    }, G = () => {
      t.disabled || (S.value = !1, b());
    }, X = () => {
      v.value = !0, b();
    }, H = () => {
      v.value = !1, b();
    }, _ = (e) => {
      u(e);
    }, z = f(() => nt(s.value, l.value, t.pageSlot));
    q(() => {
      z.value.hasFastBackward ? z.value.hasFastForward || (S.value = !1, V.value = !1) : (v.value = !1, D.value = !1);
    });
    const Y = f(() => {
      const e = T.value.selectionSuffix;
      return t.pageSizes.map((a) => typeof a == "number" ? {
        label: `${a} / ${e}`,
        value: a
      } : a);
    }), Z = f(() => {
      var e, a;
      return ((a = (e = n == null ? void 0 : n.value) === null || e === void 0 ? void 0 : e.Pagination) === null || a === void 0 ? void 0 : a.inputSize) || le(t.size);
    }), ee = f(() => {
      var e, a;
      return ((a = (e = n == null ? void 0 : n.value) === null || e === void 0 ? void 0 : e.Pagination) === null || a === void 0 ? void 0 : a.selectSize) || le(t.size);
    }), J = f(() => (s.value - 1) * h.value), N = f(() => {
      const e = s.value * h.value - 1, { itemCount: a } = t;
      return a !== void 0 && e > a - 1 ? a - 1 : e;
    }), W = f(() => {
      const { itemCount: e } = t;
      return e !== void 0 ? e : (t.pageCount || 1) * h.value;
    }), L = ot("Pagination", m, d), b = () => {
      at(() => {
        var e;
        const { value: a } = $;
        a && (a.classList.add("transition-disabled"), (e = $.value) === null || e === void 0 || e.offsetWidth, a.classList.remove("transition-disabled"));
      });
    };
    function u(e) {
      if (e === s.value)
        return;
      const { "onUpdate:page": a, onUpdatePage: M, onChange: I, simple: ne } = t;
      a && R(a, e), M && R(M, e), I && R(I, e), U.value = e, ne && (x.value = String(e));
    }
    function F(e) {
      if (e === h.value)
        return;
      const { "onUpdate:pageSize": a, onUpdatePageSize: M, onPageSizeChange: I } = t;
      a && R(a, e), M && R(M, e), I && R(I, e), E.value = e, l.value < s.value && u(l.value);
    }
    function te() {
      if (t.disabled)
        return;
      const e = Math.min(s.value + 1, l.value);
      u(e);
    }
    function o() {
      if (t.disabled)
        return;
      const e = Math.max(s.value - 1, 1);
      u(e);
    }
    function ae() {
      if (t.disabled)
        return;
      const e = Math.min(z.value.fastForwardTo, l.value);
      u(e);
    }
    function w() {
      if (t.disabled)
        return;
      const e = Math.max(z.value.fastBackwardTo, 1);
      u(e);
    }
    function O(e) {
      F(e);
    }
    function A() {
      const e = parseInt(x.value);
      Number.isNaN(e) || (u(Math.max(1, Math.min(e, l.value))), t.simple || (x.value = ""));
    }
    function c() {
      A();
    }
    function Q(e) {
      if (!t.disabled)
        switch (e.type) {
          case "page":
            u(e.label);
            break;
          case "fast-backward":
            w();
            break;
          case "fast-forward":
            ae();
            break;
        }
    }
    function B(e) {
      x.value = e.replace(/\D+/g, "");
    }
    q(() => {
      s.value, h.value, b();
    });
    const C = f(() => {
      const { size: e } = t, { self: { buttonBorder: a, buttonBorderHover: M, buttonBorderPressed: I, buttonIconColor: ne, buttonIconColorHover: he, buttonIconColorPressed: ve, itemTextColor: be, itemTextColorHover: we, itemTextColorPressed: Ce, itemTextColorActive: ke, itemTextColorDisabled: xe, itemColor: Fe, itemColorHover: Pe, itemColorPressed: Se, itemColorActive: ze, itemColorActiveHover: Me, itemColorDisabled: Ie, itemBorder: Be, itemBorderHover: ye, itemBorderPressed: Re, itemBorderActive: $e, itemBorderDisabled: Ne, itemBorderRadius: Oe, jumperTextColor: Ae, jumperTextColorDisabled: je, buttonColor: Te, buttonColorHover: Ue, buttonColorPressed: Ee, [r("itemPadding", e)]: Ve, [r("itemMargin", e)]: De, [r("inputWidth", e)]: He, [r("selectWidth", e)]: _e, [r("inputMargin", e)]: Je, [r("selectMargin", e)]: We, [r("jumperFontSize", e)]: Le, [r("prefixMargin", e)]: Qe, [r("suffixMargin", e)]: qe, [r("itemSize", e)]: Ke, [r("buttonIconSize", e)]: Ge, [r("itemFontSize", e)]: Xe, [`${r("itemMargin", e)}Rtl`]: Ye, [`${r("inputMargin", e)}Rtl`]: Ze }, common: { cubicBezierEaseInOut: et } } = g.value;
      return {
        "--n-prefix-margin": Qe,
        "--n-suffix-margin": qe,
        "--n-item-font-size": Xe,
        "--n-select-width": _e,
        "--n-select-margin": We,
        "--n-input-width": He,
        "--n-input-margin": Je,
        "--n-input-margin-rtl": Ze,
        "--n-item-size": Ke,
        "--n-item-text-color": be,
        "--n-item-text-color-disabled": xe,
        "--n-item-text-color-hover": we,
        "--n-item-text-color-active": ke,
        "--n-item-text-color-pressed": Ce,
        "--n-item-color": Fe,
        "--n-item-color-hover": Pe,
        "--n-item-color-disabled": Ie,
        "--n-item-color-active": ze,
        "--n-item-color-active-hover": Me,
        "--n-item-color-pressed": Se,
        "--n-item-border": Be,
        "--n-item-border-hover": ye,
        "--n-item-border-disabled": Ne,
        "--n-item-border-active": $e,
        "--n-item-border-pressed": Re,
        "--n-item-padding": Ve,
        "--n-item-border-radius": Oe,
        "--n-bezier": et,
        "--n-jumper-font-size": Le,
        "--n-jumper-text-color": Ae,
        "--n-jumper-text-color-disabled": je,
        "--n-item-margin": De,
        "--n-item-margin-rtl": Ye,
        "--n-button-icon-size": Ge,
        "--n-button-icon-color": ne,
        "--n-button-icon-color-hover": he,
        "--n-button-icon-color-pressed": ve,
        "--n-button-color-hover": Ue,
        "--n-button-color": Te,
        "--n-button-color-pressed": Ee,
        "--n-button-border": a,
        "--n-button-border-hover": M,
        "--n-button-border-pressed": I
      };
    }), k = j ? dt("pagination", f(() => {
      let e = "";
      const { size: a } = t;
      return e += a[0], e;
    }), C, t) : void 0;
    return {
      rtlEnabled: L,
      mergedClsPrefix: d,
      locale: T,
      selfRef: $,
      mergedPage: s,
      pageItems: f(() => z.value.items),
      mergedItemCount: W,
      jumperValue: x,
      pageSizeOptions: Y,
      mergedPageSize: h,
      inputSize: Z,
      selectSize: ee,
      mergedTheme: g,
      mergedPageCount: l,
      startIndex: J,
      endIndex: N,
      showFastForwardMenu: V,
      showFastBackwardMenu: D,
      fastForwardActive: S,
      fastBackwardActive: v,
      handleMenuSelect: _,
      handleFastForwardMouseenter: K,
      handleFastForwardMouseleave: G,
      handleFastBackwardMouseenter: X,
      handleFastBackwardMouseleave: H,
      handleJumperInput: B,
      handleBackwardClick: o,
      handleForwardClick: te,
      handlePageItemClick: Q,
      handleSizePickerChange: O,
      handleQuickJumperChange: c,
      cssVars: j ? void 0 : C,
      themeClass: k == null ? void 0 : k.themeClass,
      onRender: k == null ? void 0 : k.onRender
    };
  },
  render() {
    const { $slots: t, mergedClsPrefix: n, disabled: d, cssVars: j, mergedPage: m, mergedPageCount: g, pageItems: T, showSizePicker: $, showQuickJumper: U, mergedTheme: p, locale: E, inputSize: s, selectSize: h, mergedPageSize: l, pageSizeOptions: x, jumperValue: S, simple: v, prev: V, next: D, prefix: K, suffix: G, label: X, goto: H, handleJumperInput: _, handleSizePickerChange: z, handleBackwardClick: Y, handlePageItemClick: Z, handleForwardClick: ee, handleQuickJumperChange: J, onRender: N } = this;
    N == null || N();
    const W = t.prefix || K, L = t.suffix || G, b = V || t.prev, u = D || t.next, F = X || t.label;
    return i(
      "div",
      { ref: "selfRef", class: [
        `${n}-pagination`,
        this.themeClass,
        this.rtlEnabled && `${n}-pagination--rtl`,
        d && `${n}-pagination--disabled`,
        v && `${n}-pagination--simple`
      ], style: j },
      W ? i("div", { class: `${n}-pagination-prefix` }, W({
        page: m,
        pageSize: l,
        pageCount: g,
        startIndex: this.startIndex,
        endIndex: this.endIndex,
        itemCount: this.mergedItemCount
      })) : null,
      this.displayOrder.map((te) => {
        switch (te) {
          case "pages":
            return i(
              oe,
              null,
              i("div", { class: [
                `${n}-pagination-item`,
                !b && `${n}-pagination-item--button`,
                (m <= 1 || m > g || d) && `${n}-pagination-item--disabled`
              ], onClick: Y }, b ? b({
                page: m,
                pageSize: l,
                pageCount: g,
                startIndex: this.startIndex,
                endIndex: this.endIndex,
                itemCount: this.mergedItemCount
              }) : i(y, { clsPrefix: n }, {
                default: () => this.rtlEnabled ? i(ue, null) : i(ce, null)
              })),
              v ? i(
                oe,
                null,
                i(
                  "div",
                  { class: `${n}-pagination-quick-jumper` },
                  i(de, { value: S, onUpdateValue: _, size: s, placeholder: "", disabled: d, theme: p.peers.Input, themeOverrides: p.peerOverrides.Input, onChange: J })
                ),
                " / ",
                g
              ) : T.map((o, ae) => {
                let w, O, A;
                const { type: c } = o;
                switch (c) {
                  case "page":
                    const B = o.label;
                    F ? w = F({
                      type: "page",
                      node: B,
                      active: o.active
                    }) : w = B;
                    break;
                  case "fast-forward":
                    const C = this.fastForwardActive ? i(y, { clsPrefix: n }, {
                      default: () => this.rtlEnabled ? i(me, null) : i(fe, null)
                    }) : i(y, { clsPrefix: n }, { default: () => i(ge, null) });
                    F ? w = F({
                      type: "fast-forward",
                      node: C,
                      active: this.fastForwardActive || this.showFastForwardMenu
                    }) : w = C, O = this.handleFastForwardMouseenter, A = this.handleFastForwardMouseleave;
                    break;
                  case "fast-backward":
                    const k = this.fastBackwardActive ? i(y, { clsPrefix: n }, {
                      default: () => this.rtlEnabled ? i(fe, null) : i(me, null)
                    }) : i(y, { clsPrefix: n }, { default: () => i(ge, null) });
                    F ? w = F({
                      type: "fast-backward",
                      node: k,
                      active: this.fastBackwardActive || this.showFastBackwardMenu
                    }) : w = k, O = this.handleFastBackwardMouseenter, A = this.handleFastBackwardMouseleave;
                    break;
                }
                const Q = i("div", { key: ae, class: [
                  `${n}-pagination-item`,
                  o.active && `${n}-pagination-item--active`,
                  c !== "page" && (c === "fast-backward" && this.showFastBackwardMenu || c === "fast-forward" && this.showFastForwardMenu) && `${n}-pagination-item--hover`,
                  d && `${n}-pagination-item--disabled`,
                  c === "page" && `${n}-pagination-item--clickable`
                ], onClick: () => {
                  Z(o);
                }, onMouseenter: O, onMouseleave: A }, w);
                if (c === "page" && !o.mayBeFastBackward && !o.mayBeFastForward)
                  return Q;
                {
                  const B = o.type === "page" ? o.mayBeFastBackward ? "fast-backward" : "fast-forward" : o.type;
                  return i(ft, { to: this.to, key: B, disabled: d, trigger: "hover", virtualScroll: !0, style: { width: "60px" }, theme: p.peers.Popselect, themeOverrides: p.peerOverrides.Popselect, builtinThemeOverrides: {
                    peers: {
                      InternalSelectMenu: {
                        height: "calc(var(--n-option-height) * 4.6)"
                      }
                    }
                  }, nodeProps: () => ({
                    style: {
                      justifyContent: "center"
                    }
                  }), show: c === "page" ? !1 : c === "fast-backward" ? this.showFastBackwardMenu : this.showFastForwardMenu, onUpdateShow: (C) => {
                    c !== "page" && (C ? c === "fast-backward" ? this.showFastBackwardMenu = C : this.showFastForwardMenu = C : (this.showFastBackwardMenu = !1, this.showFastForwardMenu = !1));
                  }, options: o.type !== "page" ? o.options : [], onUpdateValue: this.handleMenuSelect, scrollable: !0, showCheckmark: !1 }, { default: () => Q });
                }
              }),
              i("div", { class: [
                `${n}-pagination-item`,
                !u && `${n}-pagination-item--button`,
                {
                  [`${n}-pagination-item--disabled`]: m < 1 || m >= g || d
                }
              ], onClick: ee }, u ? u({
                page: m,
                pageSize: l,
                pageCount: g,
                itemCount: this.mergedItemCount,
                startIndex: this.startIndex,
                endIndex: this.endIndex
              }) : i(y, { clsPrefix: n }, {
                default: () => this.rtlEnabled ? i(ce, null) : i(ue, null)
              }))
            );
          case "size-picker":
            return !v && $ ? i(ct, Object.assign({ consistentMenuWidth: !1, placeholder: "", showCheckmark: !1, to: this.to }, this.selectProps, { size: h, options: x, value: l, disabled: d, theme: p.peers.Select, themeOverrides: p.peerOverrides.Select, onUpdateValue: z })) : null;
          case "quick-jumper":
            return !v && U ? i(
              "div",
              { class: `${n}-pagination-quick-jumper` },
              H ? H() : ut(this.$slots.goto, () => [E.goto]),
              i(de, { value: S, onUpdateValue: _, size: s, placeholder: "", disabled: d, theme: p.peers.Input, themeOverrides: p.peerOverrides.Input, onChange: J })
            ) : null;
          default:
            return null;
        }
      }),
      L ? i("div", { class: `${n}-pagination-suffix` }, L({
        page: m,
        pageSize: l,
        pageCount: g,
        startIndex: this.startIndex,
        endIndex: this.endIndex,
        itemCount: this.mergedItemCount
      })) : null
    );
  }
});
export {
  Dt as default,
  pt as paginationProps
};
